// Global
export const RESET_APP = 'RESET_APP';

// Notifications
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';

// Company
export const FETCH_COMPANY_PENDING = 'FETCH_COMPANY_PENDING';
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_FAIL = 'FETCH_COMPANY_FAIL';
export const SAVE_COMPANY_KIOSK_ID = 'SAVE_COMPANY_KIOSK_ID';

// Kiosk
export const FETCH_KIOSK_SURVEYS_PENDING = 'FETCH_KIOSK_SURVEYS_PENDING';
export const FETCH_KIOSK_SURVEYS_SUCCESS = 'FETCH_KIOSK_SURVEYS_SUCCESS';
export const FETCH_KIOSK_SURVEYS_FAIL = 'FETCH_KIOSK_SURVEYS_FAIL';
export const RESET_KIOSK_SURVEYS = 'RESET_KIOSK_SURVEYS';
export const SET_KIOSK_ERROR = 'SET_KIOSK_ERROR';
export const RESET_KIOSK_ERROR = 'RESET_KIOSK_ERROR';
export const ENABLE_KIOSK_MODE = 'ENABLE_KIOSK_MODE';
export const DISABLE_KIOSK_MODE = 'DISABLE_KIOSK_MODE';

// Survey
export const FETCH_SURVEY_PENDING = 'FETCH_SURVEY_PENDING';
export const FETCH_SURVEY_SUCCESS = 'FETCH_SURVEY_SUCCESS';
export const FETCH_SURVEY_FAIL = 'FETCH_SURVEY_FAIL';
export const GOTO_NEXT_QUESTION = 'GOTO_NEXT_QUESTION';
export const GOTO_PREV_QUESTION = 'GOTO_PREV_QUESTION';
export const GOTO_QUESTION = 'GOTO_QUESTION';
export const GOTO_SUBMIT_PAGE = 'GOTO_SUBMIT_PAGE';
export const GOTO_SURVEY_PAGE = 'GOTO_SURVEY_PAGE';
export const SUBMIT_SURVEY_PENDING = 'SUBMIT_SURVEY_PENDING';
export const SUBMIT_SURVEY_SUCCESS = 'SUBMIT_SURVEY_SUCCESS';
export const SUBMIT_SURVEY_FAIL = 'SUBMIT_SURVEY_FAIL';
export const FETCH_SURVEY_RESULT_PENDING = 'FETCH_SURVEY_RESULT_PENDING';
export const FETCH_SURVEY_RESULT_FAIL = 'FETCH_SURVEY_RESULT_FAIL';
export const FETCH_SURVEY_RESULT_SUCCESS = 'FETCH_SURVEY_RESULT_SUCCESS';

// Questions
export const RESET_QUESTIONS = 'RESET_QUESTIONS';

// Answers
export const SUBMIT_ANSWER_SUCCESS = 'SUBMIT_ANSWER_SUCCESS';
export const SUBMIT_ANSWER_PENDING = 'SUBMIT_ANSWER_PENDING';
export const SUBMIT_ANSWER_FAIL = 'SUBMIT_ANSWER_FAIL';
export const REMOVE_ANSWER = 'REMOVE_ANSWER';
export const RESET_ANSWERS = 'RESET_ANSWERS';

// Languages
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_LANGUAGE_ISO = 'SET_LANGUAGE_ISO';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';
